import { useNavigate } from 'react-router-dom'

import { Button, Callout } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const TreasuryCallout = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const handleNavigate = () => {
    navigate(navigation.finance.treasury.banking.payments.paymentRequests.fullPath())
  }

  return (
    <Callout
      type="info"
      description={i18n.t('compensations.payments.treasury_cta.description')}
      title={i18n.t('compensations.payments.treasury_cta.title')}
      action={
        <Button type="secondary" onClick={handleNavigate}>
          {i18n.t('compensations.payments.treasury_cta.cta_button')}
        </Button>
      }
    />
  )
}

export default TreasuryCallout
